/* eslint-disable react/no-danger */
import { faWalking } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';
import { getImageAtSize } from '../../lib/utils';

import MapPin from '../icons/MapPin';

import styles from '../../../styles/partials/nhl-location.module.scss';

const propTypes = {
    className: PropTypes.string,
    location: AppPropTypes.location,
    featured: PropTypes.bool,
};

const defaultProps = {
    className: null,
    location: null,
    featured: false,
};

function NhlLocation({ className, featured, location }) {
    const {
        index = null,
        image = null,
        name = null,
        address = null,
        website = null,
        body = null,
    } = location || {};

    const { url: imageUrl = null, alt: imageAlt = null } = getImageAtSize(image, 'medium') || {};

    const inner = (
        <div className={styles.inner}>
            {imageUrl !== null ? (
                <img className={styles.image} src={imageUrl} alt={imageAlt} />
            ) : null}
            <div className={styles.top}>
                <div className={styles.pinContainer}>
                    <MapPin color={featured ? '#C8102E' : '#003057'} className={styles.pin} />
                    <div className={styles.index}>{index + 1}</div>
                </div>

                <h2 className={styles.name}>{name}</h2>
            </div>
            <div className={styles.content}>
                <div className={styles.itemContainer}>
                    <MapPin className={styles.icon} />
                    <div dangerouslySetInnerHTML={{ __html: address }} />
                </div>

                {body !== null ? (
                    <div className={styles.itemContainer}>
                        <span className={styles.icon}>
                            <FontAwesomeIcon icon={faWalking} />
                        </span>
                        <div className={styles.body} dangerouslySetInnerHTML={{ __html: body }} />
                    </div>
                ) : null}
            </div>
        </div>
    );
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.featured]: featured,
                    [className]: className !== null,
                },
            ])}
        >
            {website !== null ? (
                <a href={website} target="_blank" rel="noreferrer" className={styles.link}>
                    {inner}
                </a>
            ) : (
                inner
            )}
        </div>
    );
}

NhlLocation.defaultProps = defaultProps;
NhlLocation.propTypes = propTypes;

export default NhlLocation;
